import * as yup from 'yup';

export const giftingConfirmFormSchema = yup.object().shape({
  confirmAuthorised: yup
    .bool()
    .oneOf([true], 'Please confirm you are authorised to make this purchase'),
});

export default giftingConfirmFormSchema;
